export const PLAN_DEFINITIONS = [
  {
    id: "launch",
    name: "Launch",
    audience: "Casual pickup organizers",
    positioning: "Free tier for small groups.",
    monthlyPrice: 0,
    annualPriceLabel: "$0/month",
    annualPriceYear: 0,
    participantLimit: 18,
    cta: "Start Free",
    features: [
      "1 active hockey league",
      "1 rink scheduling",
      "Unlimited pickup games",
      "Public registration link",
      "1 waiver template",
      "Roster and manual check-in",
      "Email confirmations",
    ],
    freeTierBlurb: "Everything you need to run small pickup: signups, roster, one waiver.",
  },
  {
    id: "pickup-pro",
    name: "Pickup Pro",
    audience: "Recurring pickup groups",
    positioning: "For recurring pickup and growing leagues—no minimums, no extra platform fees.",
    monthlyPrice: 19,
    annualPriceLabel: "$15/month",
    annualPriceYear: 180,
    participantLimit: 75,
    cta: "Upgrade to Pickup Pro",
    features: [
      "Everything in Launch",
      "Stripe payments",
      "Multi-rink scheduling",
      "Unlimited programs",
      "Recurring memberships",
      "QR check-in",
      "Auto-reminder emails",
      "Waitlist auto-fill",
      "Refunds and credits",
      "Revenue dashboard",
      "Discount codes",
    ],
  },
  {
    id: "league",
    name: "League",
    audience: "Adult hockey leagues",
    positioning: "Full league tools: roles, waivers, payments, reporting.",
    monthlyPrice: 89,
    annualPriceLabel: "$69/month",
    annualPriceYear: 828,
    participantLimit: 500,
    cta: "Go League",
    features: [
      "Everything in Pickup Pro",
      "Owner, admin, treasurer, coach roles",
      "Multiple waiver templates",
      "Payment and incident reporting",
      "Payment plans",
      "Custom branding",
      "Financial exports",
    ],
  },
];

export const getParticipantLimitLabel = (participantLimit) => {
  return `Up to ${participantLimit} participants`;
};
